module.exports = __webpack_public_path__ + "static/media/ai-chatbot-logo.7504fc52.png";